import { baseClasses } from '@weatherbug/common';
import { UnitsProvider } from '../providers/unitsProvider';

const { AsyncAction } = baseClasses;

export const SET_UNITS = new AsyncAction('SET_UNITS');
export const SET_INITIAL_UNITS = 'SET_INITIAL_UNITS';

//TECHDEBT: rain unit is currently always English or Metric matching with temp unit's setting.  It needs to be added to the setting popup interface.

export function setUnits(unitSystem, tempUnit, windUnit, pressureUnit) {
    return {
        type: SET_UNITS.base,
        payload: setUnitsAction(unitSystem, tempUnit, windUnit, pressureUnit)
    };
}

async function setUnitsAction(unitSystem, tempUnit, windUnit, pressureUnit) {
    const op = new UnitsProvider();
    return await op.setUnits(unitSystem, tempUnit, windUnit, pressureUnit);
}

export function setInitialUnits(unitSystem, tempUnit, windUnit, pressureUnit, rainUnit) {
    return {
        type: SET_INITIAL_UNITS,
        payload: {
            unitSystem,
            tempUnit,
            windUnit,
            pressureUnit,
            rainUnit
        }
    };
}
